var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import classNames from "classnames";
const defaultProps = {
    "data-testid": "tecma-dropDown-divider",
};
const DropDownDivider = (_a) => {
    var { className, style } = _a, rest = __rest(_a, ["className", "style"]);
    const classList = classNames("tecma-dropDown-divider", className);
    return _jsx("div", Object.assign({ className: classList, style: style }, rest));
};
DropDownDivider.defaultProps = defaultProps;
export default memo(DropDownDivider);
